/* eslint-disable import/no-anonymous-default-export */
import EventEmitter from 'events';

export default new EventEmitter();
